import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getClientsActions, setClientsSearchAction } from '../../redux/actions/clientsActions';
import CreateClientModal from './modals/CreateClientModal';

const ClientsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.clients?.search);
  const [showCreateClientModal, setShowCreateClientModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setClientsSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleClientModalSubmit = async () => {
    setShowCreateClientModal(false);
    setLoading(true);
    await dispatch(getClientsActions(search));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateClientModal && (
        <CreateClientModal
          onModalSubmit={() => handleClientModalSubmit()}
          onModalClose={() => setShowCreateClientModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateClientModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default ClientsHeader;
